module.exports = __webpack_public_path__ + "img/logo.0e5f6b7b.webp";